module.exports = __webpack_public_path__ + "static/thumb_current-56b5e76c7f2e3a496a321feadbfdb1d2.jpg";